const storedCart = localStorage.getItem('cart')
const storedPercentDiscount = localStorage.getItem('percentDiscount')
const storedFixedDiscount = localStorage.getItem('fixedDiscount')

export const state = () => ({
  cart: storedCart ? JSON.parse(storedCart) : [],
  percentDiscount: storedPercentDiscount ? parseInt(storedPercentDiscount) : 0,
  fixedDiscount: storedFixedDiscount ? parseInt(storedFixedDiscount) : 0,
})

export const getters = {
  totalCart(state) {
    return state.cart.length
  },
  totalWithoutDiscount(state) {
    return state.cart.reduce(
      (total, item) => total + parseFloat(item.valorVenda),
      0
    )
  },
  totalCartPrice(state, getters) {
    const percentDiscountAmount =
      (state.percentDiscount / 100) * getters.totalWithoutDiscount
    const totalAfterPercentDiscount =
      getters.totalWithoutDiscount - percentDiscountAmount
    const totalAfterFixedDiscount =
      totalAfterPercentDiscount - state.fixedDiscount
    return totalAfterFixedDiscount
  },
  discountPrice(state, getters) {
    return getters.totalWithoutDiscount - getters.totalCartPrice
  },

  productCart(state) {
    const cartWithQuantity = []
    state.cart.forEach((produto) => {
      const produtoExistente = cartWithQuantity.find((p) => p.id === produto.id)
      if (produtoExistente) {
        produtoExistente.quantity += 1
        produtoExistente.total += produto.valorVenda
      } else {
        cartWithQuantity.push({
          ...produto,
          quantity: 1,
          total: produto.valorVenda,
        })
      }
    })
    return cartWithQuantity
  },
}

export const mutations = {
  ADD_CART(state, payload) {
    state.cart.push({ ...payload })
    localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  DELETE_CART(state, payload) {
    state.cart = state.cart.filter((e) => e.id !== payload.id)
    localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  DELETE_ONE_PRODUCT(state, productIndex) {
    state.cart.splice(productIndex, 1)
    localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  CLEAN_CART(state) {
    state.cart = []
    state.percentDiscount = 0
    state.fixedDiscount = 0
    localStorage.removeItem('cart')
    localStorage.removeItem('percentDiscount')
    localStorage.removeItem('fixedDiscount')
  },
  SET_PERCENT_DISCOUNT(state, percentDiscount) {
    state.percentDiscount = percentDiscount
    localStorage.setItem(
      'percentDiscount',
      JSON.stringify(state.percentDiscount)
    )
  },
  SET_FIXED_DISCOUNT(state, fixedDiscount) {
    state.fixedDiscount = fixedDiscount
    localStorage.setItem('fixedDiscount', JSON.stringify(state.fixedDiscount))
  },
}
export const actions = {
  adicionarCart({ commit }, payload) {
    commit('ADD_CART', payload)
  },
  deleteCart({ commit }, payload) {
    commit('DELETE_CART', payload)
  },
  deleteOneProduct({ commit, state }, productId) {
    const productIndex = state.cart.findIndex(
      (produto) => produto.id === productId
    )

    if (productIndex !== -1) {
      commit('DELETE_ONE_PRODUCT', productIndex)
    }
  },
  setPercentDiscount({ commit }, percentDiscount) {
    commit('SET_PERCENT_DISCOUNT', percentDiscount)
  },
  setFixedDiscount({ commit }, fixedDiscount) {
    commit('SET_FIXED_DISCOUNT', fixedDiscount)
  },
}
